module.exports = __webpack_public_path__ + "img/symphony_794_saddle.0d3491ad.jpg";